import { render, staticRenderFns } from "./moderatorZone.vue?vue&type=template&id=03e0c12a&scoped=true"
import script from "./moderatorZone.vue?vue&type=script&lang=js"
export * from "./moderatorZone.vue?vue&type=script&lang=js"
import style0 from "./moderatorZone.vue?vue&type=style&index=0&id=03e0c12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e0c12a",
  null
  
)

export default component.exports